import React from "react";
import DocSections from "@/pages/DocSections";

export default function PlayerHandbook() {
  return (
    <DocSections
      title="Player Handbook"
      subtitle="Standards, expectations, discipline"
      endpoint="/player-handbook"
      testid="player-handbook-page"
    />
  );
}
